<template>
  <div>
    <el-row :gutter="16" type="flex" >
      <el-col :span="4">
        <el-input v-model="crawlerVersion" clearable placeholder="输入采集日期">
        </el-input>
      </el-col>
      <el-col :span="4">
        <el-input v-model="keyword" clearable placeholder="输入检索词">
        </el-input>
      </el-col>
      <el-col :span="4">
        <el-input v-model="region" clearable placeholder="输入区域,GB,ID,JP,等">
        </el-input>
      </el-col>
      <el-col :span="4" >
        <el-button icon="el-icon-search" @click="searchPageData"
        >搜索</el-button
        >
        <el-button icon="el-icon-download" @click="exportSelectedData" alt=""
        >下载</el-button
        >
      </el-col>

    </el-row>

    <el-row style="padding-top: 16px">
      <el-pagination
          background
          @current-change="queryGoodsPage"
          layout="total, prev, pager, next"
          :total="totalItems"
          :page-size="pageSize"
      >
      </el-pagination>
    </el-row>
    <el-row style="padding-top: 16px">
      <el-table
          ref="dataTable"
          :data="users"
          style="width: 100%"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="keyword" label="日期/关键词/区域">
          <template scope="scope">
            {{ scope.row.crawlerVersion }}
            /{{ scope.row.keyword }}
            /{{ scope.row.region }}
          </template>
        </el-table-column>
        <el-table-column prop="_id" label="主键"> </el-table-column>
        <el-table-column prop="userId" label="用户ID"></el-table-column>
        <el-table-column prop="nickname" label="昵称"></el-table-column>
        <el-table-column prop="uniqueId" label="tiktok号"></el-table-column>
        <el-table-column prop="profileUrl" label="个人主页面"></el-table-column>
        <el-table-column prop="signature" label="签名"></el-table-column>
        <el-table-column prop="followerCount" label="粉丝数量"></el-table-column>
        <el-table-column label="头像" width="100">
          <template scope="scope">
            <img
                :src="scope.row.avatarUrl"
                width="70"
                height="70"
                class="head_pic"
            />
          </template>
        </el-table-column>


      </el-table>
    </el-row>
  </div>
</template>
<script>
const axios = require("axios");
export default {
  name: "tiktokUserItemSearch",
  data() {
    return {
      users: [],
      keyword: "",
      region: "",
      authorNickname: "",
      authorDouId: "",
      whether: null,
      videoTitle: "",
      crawlerVersion: null,
      currentPage: 1,
      totalItems: 0,
      pageSize: 50,
      selectedCount: 0,
    };
  },
  methods: {
    exportSelectedData() {
      let para = "";
      if (this.crawlerVersion != null && this.crawlerVersion != "") {
        para += "&crawlerVersion=" + this.crawlerVersion;
      }

      if (this.keyword !== "") {
        para += "&keyword=" + this.keyword;
      }

      if (this.region !== "") {
        para += "&region=" + this.region;
      }

      window.open("/api/tiktok/export/users?" + para);
    },
    searchPageData() {
      this.currentPage = 1;
      this.loadItemInfo(1);
    },
    queryGoodsPage(pageNum) {
      this.currentPage = pageNum;
      this.loadItemInfo(pageNum);
    },
    loadItemInfo(pageNum) {
      var _this = this;
      let para = "";
      if (this.crawlerVersion != null && this.crawlerVersion != "") {
        para += "&crawlerVersion=" + this.crawlerVersion;
      }

      if (this.keyword !== "") {
        para += "&keyword=" + this.keyword.replace('+','%2B');
      }

      if (this.region !== "") {
        para += "&region=" + this.region;
      }


      axios
          .get("/api/tiktok/user/queryPage?currentPage=" + pageNum + "&pageSize=50" + para)
          .then((content) => {
            if (content.data.status === 0) {
              console.log(content.data.data)
              _this.users = content.data.data;
              _this.totalItems = content.data.total;
            }
          });
    },
  },
  mounted() {
    this.loadItemInfo(1);
  },
};
</script>
